import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerMoveEmployee'

export default (managerId, targetManagerId, employeeId, alternativeCampaignName) => {
  const data = { managerId, targetManagerId, employeeId }
  if (alternativeCampaignName) {
    data.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    ManagersService.moveEmployee,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerMoveEmployee.js